import React, { useEffect, useState } from 'react';
import UI from '../../ui';
import { Instructions } from '../Instructions';
import { PackingMethodIdMap } from '../Mappings';
import { InboundStatus, ShippingStatus } from '../Status';
import { ValidationErrors } from '../Validations';

const { WrappedDropdownWithLabel } = UI;

const ShippingDropdown = ({
	onShippingMethodChange,
	updateInboundInstructions,
	selectedShippingMethod = ShippingStatus.Zorbit,
	inboundStatus,
	saveDefaultInboundSelection,
	isMobile,
	validations,
	updateValidation,
}) => {
	const [shippingMethod, setShippingMethod] = useState(selectedShippingMethod);
	const disableShippingMethod =
		inboundStatus === InboundStatus.Processing ||
		inboundStatus === InboundStatus.Completed ||
		inboundStatus === InboundStatus.Cancelled;

	useEffect(() => {
		setShippingMethod(selectedShippingMethod);
	}, [selectedShippingMethod]);

	const shippingOptions = [
		{
			shipMethod: 'Zorbit',
			name: 'Send with Zorbit (UPS)',
		},
		{
			shipMethod: 'Self',
			name: 'Send on my own',
		},
	];

	const onShippingSelectionChange = selectedShipMethod => {
		const newShippingMethod = selectedShipMethod.value;
		const updatedValidations = validations;

		saveDefaultInboundSelection('shippingMethod', newShippingMethod);
		setShippingMethod(newShippingMethod);
		if (newShippingMethod === ShippingStatus.Zorbit) {
			onShippingMethodChange({
				expectedArrivalDate: '',
				packagingType: PackingMethodIdMap.Boxes,
				shippingMethod: newShippingMethod,
			});
		} else {
			onShippingMethodChange({
				expectedArrivalDate: '',
				shippingMethod: newShippingMethod,
			});
		}

		updatedValidations.shippingMethod = 1;
		updatedValidations.shipFrom =
			newShippingMethod === ShippingStatus.Zorbit ? 0 : 1;
		updatedValidations.arrival =
			newShippingMethod === ShippingStatus.Self ? 0 : 1;
		updateValidation(updatedValidations);
	};

	const onDropdownFocus = () => {
		updateInboundInstructions(
			Instructions.headers.inbound.shippingMethod,
			Instructions.instructions.inbound.shippingMethod
		);
	};

	return (
		<div className="shipping-method">
			{disableShippingMethod && (
				<div className="read-only-label-container">
					<div className="read-only-label">Shipping Method</div>
					<div className="read-only-text">
						{shippingMethod === ShippingStatus.Zorbit
							? 'Send with Zorbit (UPS)'
							: 'Send on my own'}
					</div>
				</div>
			)}
			{!disableShippingMethod && (
				<WrappedDropdownWithLabel
					name="shippingmethoddropdown"
					label="Shipping Method"
					isInputInvalid={validations.shippingMethod === -1}
					showErrorBelow={isMobile}
					errorMessage={ValidationErrors.shippingMethod}
					uiElementConfig={{
						name: 'shippingMethod',
						value: shippingMethod,
						onChange: onShippingSelectionChange,
						onFocus: onDropdownFocus,
						options: shippingOptions,
						optionLabel: 'name',
						optionValue: 'shipMethod',
						dataqa: 'shipping-method',
					}}
				/>
			)}
		</div>
	);
};

export default ShippingDropdown;
